{
  "familyId": "REK-TAFELS-UITBREIDEN",
  "questions": [
    {
      "id": "REK-TAFELS-UITBREIDEN-001",
      "familyId": "REK-TAFELS-UITBREIDEN",
      "module": "Basisrekenen",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "tafels",
      "subSkill": "tafels_uitgebreid",
      "questionType": "fill_in",
      "question": "Hoeveel is 12 × 7?",
      "options": [],
      "correctAnswer": "84",
      "data": {
        "acceptedAnswers": ["84"]
      },
      "stimulusAids": [
        {
          "type": "ratio",
          "data": {
            "label": "Tafel van 12 splitsen",
            "headers": ["×", "10", "2", "12"],
            "rows": [
              ["7", "70", "14", "?"]
            ]
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Tafel van 12 — splits in 10 + 2",
            "content": "12 × 7: splits 12 in 10 + 2. Reken: 10 × 7 = 70 en 2 × 7 = 14. Tel op: 70 + 14 = 84.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "tafels_twaalf_splitsen",
      "variantIndex": 1,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.68,
      "feedback": {
        "explanationText": "12 × 7 = 84. Splits 12 in 10 + 2: eerst 10 × 7 = 70, dan 2 × 7 = 14. Tel op: 70 + 14 = 84. Deze truc werkt voor alle tafels boven de 10!",
        "solutionSteps": [
          "Splits 12 in 10 + 2",
          "10 × 7 = 70",
          "2 × 7 = 14",
          "70 + 14 = 84"
        ]
      }
    },
    {
      "id": "REK-TAFELS-UITBREIDEN-002",
      "familyId": "REK-TAFELS-UITBREIDEN",
      "module": "Basisrekenen",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "tafels",
      "subSkill": "tafels_uitgebreid",
      "questionType": "fill_in",
      "question": "Hoeveel is 15 × 6?",
      "options": [],
      "correctAnswer": "90",
      "data": {
        "acceptedAnswers": ["90"]
      },
      "stimulusAids": [
        {
          "type": "ratio",
          "data": {
            "label": "Tafel van 15 splitsen",
            "headers": ["×", "10", "5", "15"],
            "rows": [
              ["6", "60", "30", "?"]
            ]
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Tafel van 15 — splits in 10 + 5",
            "content": "15 × 6: splits 15 in 10 + 5. Reken: 10 × 6 = 60 en 5 × 6 = 30. Tel op: 60 + 30 = 90. Of: 15 × 6 = 3 × 5 × 6 = 3 × 30 = 90.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "tafels_vijftien_splitsen",
      "variantIndex": 2,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "15 × 6 = 90. Splits 15 in 10 + 5: 10 × 6 = 60 en 5 × 6 = 30, samen 90. Of denk: 15 × 6 = de helft van 30 × 6 = de helft van 180 = 90.",
        "solutionSteps": [
          "Splits 15 in 10 + 5",
          "10 × 6 = 60",
          "5 × 6 = 30",
          "60 + 30 = 90"
        ]
      }
    },
    {
      "id": "REK-TAFELS-UITBREIDEN-003",
      "familyId": "REK-TAFELS-UITBREIDEN",
      "module": "Basisrekenen",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "tafels",
      "subSkill": "tafels_uitgebreid",
      "questionType": "multiple_choice",
      "question": "Hoeveel is 25 × 8?",
      "options": ["200", "175", "225", "180"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "ratio",
          "data": {
            "label": "Tafel van 25 (kwarten)",
            "headers": ["×", "4", "8"],
            "rows": [
              ["25", "100", "?"]
            ]
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Tafel van 25 — kwarten",
            "content": "25 × 8: 25 past 4 keer in 100. Dus 25 × 8 = 25 × 4 × 2 = 100 × 2 = 200. Of: 25 × 8 = (100 ÷ 4) × 8 = 800 ÷ 4 = 200.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "tafels_vijfentwintig_kwarten",
      "variantIndex": 3,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "25 × 8 = 200. Handige truc: 25 × 4 = 100, dus 25 × 8 = 100 × 2 = 200. De tafel van 25 is handig omdat 25 een kwart van 100 is.",
        "solutionSteps": [
          "Herken: 25 × 4 = 100",
          "25 × 8 = 25 × 4 × 2",
          "= 100 × 2 = 200"
        ],
        "distractorExplanations": {
          "0": "Goed! 25 × 8 = 200. Truc: 25 × 4 = 100, dus 25 × 8 = 200.",
          "1": "Je dacht waarschijnlijk aan 25 × 7 = 175. Maar het is 25 × 8, niet 25 × 7. Onthoud: 25 × 8 = 200.",
          "2": "Je dacht waarschijnlijk aan 25 × 9 = 225. Maar het is 25 × 8, niet 25 × 9. Onthoud: 25 × 8 = 200.",
          "3": "Je dacht waarschijnlijk aan 20 × 9 = 180. Maar het is 25 × 8. Truc: 25 × 4 = 100, dus 25 × 8 = 200."
        }
      }
    },
    {
      "id": "REK-TAFELS-UITBREIDEN-004",
      "familyId": "REK-TAFELS-UITBREIDEN",
      "module": "Basisrekenen",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "tafels",
      "subSkill": "tafels_uitgebreid",
      "questionType": "fill_in",
      "question": "Hoeveel is 72 ÷ 8?",
      "options": [],
      "correctAnswer": "9",
      "data": {
        "acceptedAnswers": ["9"]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Deeltafels — omgekeerde tafel",
            "content": "72 ÷ 8 = ? Denk: welk getal × 8 = 72? De tafel van 8: 8, 16, 24, 32, 40, 48, 56, 64, 72. Het 9e getal is 72, dus 72 ÷ 8 = 9.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "deeltafels_omgekeerd",
      "variantIndex": 4,
      "citoDifficulty": 0.34,
      "citoDiscrimination": 0.66,
      "feedback": {
        "explanationText": "72 ÷ 8 = 9. Delen is de omgekeerde bewerking van vermenigvuldigen. Denk: welk getal × 8 = 72? Antwoord: 9 × 8 = 72, dus 72 ÷ 8 = 9.",
        "solutionSteps": [
          "Vraag: welk getal × 8 = 72?",
          "Tafel van 8: ... 56, 64, 72",
          "9 × 8 = 72, dus 72 ÷ 8 = 9"
        ]
      }
    },
    {
      "id": "REK-TAFELS-UITBREIDEN-005",
      "familyId": "REK-TAFELS-UITBREIDEN",
      "module": "Basisrekenen",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "tafels",
      "subSkill": "tafels_uitgebreid",
      "questionType": "multiple_choice",
      "question": "Een tuinman plant bloembollen. Hij heeft 11 rijen en plant 9 bollen per rij. Hoeveel bloembollen plant hij in totaal?",
      "options": ["99", "90", "108", "88"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Tafel van 11 — splits in 10 + 1",
            "content": "11 × 9: splits 11 in 10 + 1. Reken: 10 × 9 = 90 en 1 × 9 = 9. Tel op: 90 + 9 = 99.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "tafels_elf_context",
      "variantIndex": 5,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.68,
      "feedback": {
        "explanationText": "11 × 9 = 99. Splits 11 in 10 + 1: 10 × 9 = 90 en 1 × 9 = 9, samen 99. De tafel van 11 is makkelijk: het getal herhaalt zich (11, 22, 33, ... tot 99).",
        "solutionSteps": [
          "Herken: 11 rijen × 9 bollen = 11 × 9",
          "Splits: 10 × 9 = 90, plus 1 × 9 = 9",
          "Antwoord: 90 + 9 = 99"
        ],
        "distractorExplanations": {
          "0": "Goed! 11 × 9 = 99 bloembollen.",
          "1": "Je dacht waarschijnlijk aan 10 × 9 = 90. Maar er zijn 11 rijen, niet 10. Nog 1 × 9 = 9 erbij: 90 + 9 = 99.",
          "2": "Je dacht waarschijnlijk aan 12 × 9 = 108. Maar er zijn 11 rijen, niet 12. 11 × 9 = 99.",
          "3": "Je dacht waarschijnlijk aan 11 × 8 = 88. Maar er zijn 9 bollen per rij, niet 8. 11 × 9 = 99."
        }
      }
    },
    {
      "id": "REK-TAFELS-UITBREIDEN-006",
      "familyId": "REK-TAFELS-UITBREIDEN",
      "module": "Basisrekenen",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "tafels",
      "subSkill": "tafels_uitgebreid",
      "questionType": "multiplication_grid",
      "question": "Vul het tafelrooster in",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "mode": "cross_table",
        "rows": [6, 7, 8, 9],
        "cols": [6, 7, 8, 9],
        "hiddenCells": [
          {"row": 0, "col": 1},
          {"row": 0, "col": 3},
          {"row": 1, "col": 0},
          {"row": 1, "col": 2},
          {"row": 2, "col": 1},
          {"row": 2, "col": 3},
          {"row": 3, "col": 0},
          {"row": 3, "col": 2}
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Kruistafel — zoek patronen!",
            "content": "In een kruistafel vermenigvuldig je het rijgetal met het kolomgetal. Tip: kijk naar de diagonaal (6×6=36, 7×7=49, 8×8=64, 9×9=81) — dat zijn de kwadraten! Vanuit een kwadraat kun je andere antwoorden afleiden.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "tafels_kruistafel_moeilijk",
      "variantIndex": 6,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "In een kruistafel vermenigvuldig je het rijgetal met het kolomgetal. De ontbrekende antwoorden: 6×7=42, 6×9=54, 7×6=42, 7×8=56, 8×7=56, 8×9=72, 9×6=54, 9×8=72. Let op de symmetrie: 6×7 = 7×6 = 42!",
        "solutionSteps": [
          "6 × 7 = 42 en 6 × 9 = 54",
          "7 × 6 = 42 en 7 × 8 = 56",
          "8 × 7 = 56 en 8 × 9 = 72",
          "9 × 6 = 54 en 9 × 8 = 72",
          "Tip: gebruik symmetrie! a × b = b × a"
        ]
      }
    }
  ]
}